// @flow

import React, { Component }          from 'react';
import { connect }                   from 'react-redux';
import { getTranslate }              from 'react-localize-redux';
import $                             from 'jquery';
import './index.css';

class Help extends Component {

  state: {
    keyword: string;
  };

  constructor(props) {
    super(props);
    this.state = {
      keyword: "",
    }

    this._renderCategories = this._renderCategories.bind(this);
    this._renderQuestions = this._renderQuestions.bind(this);
    this._handleChange = this._handleChange.bind(this);
  }

  _renderCategory = (category) => {
    return (
      <div key={category.name}>
        <div className="ttl-bar">
          <h2>{category.name}</h2>
        </div>
        <div className="faq-cat-cont">
          {category.questions.map(this._renderQuestions)}
        </div>
      </div>
    )
  }

  _renderCategories = (categories) => {
    let searchedCategories = categories.map(this._searchFilter);
    let filteredCategories = searchedCategories.filter(item => item.questions.length > 0);

    if ( filteredCategories.length !== 0 ) {
      return (
        <div className="faq-cat-box">{ filteredCategories.map(this._renderCategory) }</div>
      )
    } else {
      return (
        <div className="faq-cat-box">{ this._renderNoQuestions() }</div>
      )
    }
  }

  // using jquery to animations
  _toggleText(e) {
    $(e.currentTarget).siblings('.faq-text').animate({
      height: "toggle",
      opacity: "toggle"
    }, 350);
    e.currentTarget.firstChild.firstChild.classList.toggle('fa-caret-right');
  }

  _renderQuestions = (question) => {
    return (
      <div key={question.title}>
        <div className="faq-heading-question" onClick={(e) => {this._toggleText(e)}}>
          <div className="faq-icon-holder">
            <i className="fa fa fa-caret-down fa-caret-right" aria-hidden="true" />
          </div>
          <span>{question.title}</span>
        </div>
        <div className="faq-hidden faq-text">
          <div dangerouslySetInnerHTML={{ __html: question.text }} />
        </div>
      </div>
    )
  }

  _searchFilter = (category) => {
    let reg = new RegExp(this.state.keyword, "i");
    let resultQuestion = category.questions.filter((item) => {
      if (item.title.match(reg, "i") || item.text.match(reg, "i")) {
        return item;
      } else {
        return false;
      }
    })
    let results = { name: category.name, questions: resultQuestion};
    return results;
  }

  _handleChange = (e) => {
    this.setState({ keyword: e.target.value });
  }

  _renderNoQuestions = () => {
    const { translate } = this.props;
    return (
      <div className="faq-no-questions">
        {translate('faq.no_questions')}
      </div>
    )
  }

  render() {
    const { faq, translate } = this.props;
    if (!faq || !faq.categories) { return null };
    const categories = this._renderCategories(faq.categories)
    return (
      <div>
        <div className="faq-header">
          <div className="title-box"><span className="faq-header--title">{translate('faq.title')}</span></div>
          <div className="subtitle-box"><span className="faq-header--sub-title">{translate('faq.need_help')}</span></div>
          <div>
            <input
              type="text"
              className="faq-header--input"
              placeholder={translate('faq.keywords')}
              value={this.state.keyword}
              onChange={this._handleChange}
            />
          </div>
        </div>
        { categories }
      </div>
    );
  }
}



const mapStateToProps = state => ({
  translate: getTranslate(state.locale),
  faq: state.faq
});

export default connect(mapStateToProps)(Help);



// WEBPACK FOOTER //
// ./src/components/main/help/index.js